import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=324e22b6&scoped=true"
import script from "./MessageItem.vue?vue&type=script&lang=js"
export * from "./MessageItem.vue?vue&type=script&lang=js"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=324e22b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e22b6",
  null
  
)

export default component.exports